import ContractMdl from '@/models/HumanResource/HrContract'
export default async data => {
    try {
        const response = await new ContractMdl(data).save()
        return response
    } catch (error) {
        return error.response.data
    }
}
